import React from 'react';
import { usePortalContext } from '../context/PortalContext';
import { MarketingAdminPanel } from '../marketing/MarketingAdminPanel';
import { hasElevatedAccess, PORTAL_ROLES } from '../utils/roles';

const MarketingAdmin = (): JSX.Element => {
  const { tenant } = usePortalContext();
  const hasAccess = hasElevatedAccess(tenant?.roles, PORTAL_ROLES.marketingAdmin);

  if (!hasAccess) {
    return (
      <div className="card">
        <h3>Marketing admin access required</h3>
        <p className="muted">
          You do not have permission to manage marketing content. Contact a platform administrator if you
          believe this is an error.
        </p>
      </div>
    );
  }

  return <MarketingAdminPanel />;
};

export default MarketingAdmin;
